console.log('fettercairn theme - scripts.js');

